import { useEffect } from 'react';
import { JOURNEY_STATE, useApplicationState } from '../../App.state';
import { MatchMakerResult } from './MatchMakerResult';

export function SummaryPage(): JSX.Element {
  const { dispatch } = useApplicationState();

  useEffect(() => {
    dispatch({ type: 'updateJourneyStatus', journeyStatus: JOURNEY_STATE.SUMMARY });
  }, [dispatch]);

  return <MatchMakerResult />;
}
